import { IllustrationPens } from './IllustrationPens';
import { StyledContainer, Title, TitleTopPart, TitleBottomPart, TextBlock, AsideText } from './SectionFour.styled';

export const SectionFour: React.FC = () => {
  return (
    <section>
      <StyledContainer>
        <Title>To join efforts and act</Title>
        <TitleTopPart role="presentation" aria-hidden>
          to join efforts
        </TitleTopPart>
        <TitleBottomPart role="presentation" aria-hidden>
          and act
        </TitleBottomPart>
        <TextBlock
          text={
            <>
              <AsideText>
                EX CORP, in its turn, will welcome any offers of collaboration on solving these socially important
                issues.
              </AsideText>
              <AsideText>
                If you have any questions, suggestions, or ideas, feel free to contact us at{' '}
                <a href="mailto:goodenough@excorp.gg">goodenough@excorp.gg</a>
              </AsideText>
              <AsideText>
                To start contributing to the cause, the esports outlet <a href="https://blix.gg/">BLIX.GG</a>, one of EX{' '}
                CORP.&apos;s media assets, makes a commitment for a one-year period to produce and promote content on{' '}
                women in esports industry, including female players, women in key managerial roles, special events, as{' '}
                well as to provide extensive coverage to women&apos;s tournaments and include them in the tournament{' '}
                calendar.
              </AsideText>
            </>
          }
        />
        <IllustrationPens />
      </StyledContainer>
    </section>
  );
};
